module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0957.2814d5bc.jpg";